<template>
    <v-form v-model="currentContactInfo.isValid" ref="contactInfoForm">
        <v-container class="py-0 py-sm-0">
            <v-row>
                <v-col class="py-0 py-sm-0" style="min-height: 445px;">
                    <label for="Phone">Owner Phone Number</label>
                    <v-text-field v-model="currentContactInfo.formData.phone"
                                  v-facade="'(###)-###-####'"
                                  placeholder="(___)-___-____"
                                  name="Phone"
                                  id="phone"
                                  class="mt-1"
                                  style="width: 50%; min-width: 170px;"
                                  type="tel"
                                  autocomplete="off"
                                  required
                                  :rules="phoneRules"
                                  @change="phoneChanged"
                                  background-color="white"
                                  :error-messages="errors"
                                  outlined
                                  solo>
                    </v-text-field>
                    <label for="Phone">Re-enter phone</label>
                    <v-text-field v-model="currentContactInfo.formData.phoneConfirm"
                                  v-facade="'(###)-###-####'"
                                  placeholder="(___)-___-____"
                                  name="PhoneConfirm"
                                  id="phoneConfirm"
                                  class="mt-1"
                                  style="width: 50%; min-width: 170px;"
                                  type="tel"
                                  autocomplete="off"
                                  required
                                  :rules="phoneRulesConfirm"
                                  @change="confirmPhoneChanges"
                                  background-color="white"
                                  outlined
                                  solo>
                    </v-text-field>

                    <label style="display: block;" class="mt-1 mb-3">{{smsOptinLabel}}</label>
                    <v-btn-toggle v-model="currentContactInfo.formData.optIn" class="has-2-toggles mb-3">
                        <v-btn value="1" large outlined color="primary" light>Yes</v-btn>
                        <v-btn value="0" large outlined color="primary" light>No</v-btn>
                    </v-btn-toggle>
                    <small class="mt-2" v-if="currentContactInfo.formData.optIn === '1'">
                        {{ smsDisclaimer }}
                    </small>
                    <small v-if="currentContactInfo.formData.optIn === '0'" v-html="optOutWarning">
                    </small>

                    <label v-if="currentModel.settings.showEmailField" for="Email" class="mt-5">{{'Email ' + (currentModel.settings.emailFieldRequired ? '(required)' : '(optional)')}}</label>
                    <v-text-field v-if="currentModel.settings.showEmailField"
                                  v-model="currentContactInfo.formData.email"
                                  name="Email"
                                  type="email"
                                  class="mt-1"
                                  autocomplete="off"
                                  :required="currentModel.settings.emailFieldRequired"
                                  :rules="emailRules"
                                  background-color="white"
                                  outlined
                                  solo>
                    </v-text-field>
                    <label style="display: block;" class="mt-7 mb-3">Owner(s)</label>
                    <v-progress-circular :indeterminate="true" size="20" width="2"
                                         v-if="$store.state.loadingContacts">
                    </v-progress-circular>
                    <v-autocomplete style="display: inline-block; width: 85%;"
                                    v-on:change="ownerSelectionChanged()"
                                    v-model="$store.state.ezyvet.contact"
                                    :items="ownerContacts"
                                    label="Select your name"
                                    item-text="fullName"
                                    background-color="white"
                                    outlined
                                    solo
                                    return-object>
                    </v-autocomplete>
                    <v-btn raised fab class="elevation-5 v-size--small" 
                           style="margin-left: 15px" 
                           v-on:click="nextStep"
                           :disabled="ownerContactIsValid">
                        New
                    </v-btn>
                  </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    /* eslint-disable no-useless-escape */
    import ContextualMixin from '../mixins/contextualMixin'
    import WalkinMixin from '../mixins/walkinFormMixin'
    import axios from 'axios'

    export default {
        name: 'ContactInfo',
        mixins: [ContextualMixin, WalkinMixin],
        data() {
            return {
                errors: [],
                phoneRules: [
                    v => !!v || 'Phone is required.',
                    () => /^(?:(1\-?)|(\+1 ?))?\(?\d{3}\)?[\-\.\s]?\d{3}[\-\.\s]?\d{4}$/.test(this.unmaskedPhone) && /^(\d)(?!\1+$)\d{9}$/.test(this.unmaskedPhone) || 'Phone is invalid',
                    () => {
                        let value = true;
                        let tis = this;
                        this.validatePhone().then((x) => {
                            if (x === false) {
                                tis.errors = ['Fake phone number'];
                            } else {
                                tis.errors = [];
                            }
                        });
                        return value;
                    }
                ],
                phoneRulesConfirm: [
                    v => !!v || 'Re-enter phone is required.',
                    () => /^(?:(1\-?)|(\+1 ?))?\(?\d{3}\)?[\-\.\s]?\d{3}[\-\.\s]?\d{4}$/.test(this.unmaskedPhoneConfirm) && /^(\d)(?!\1+$)\d{9}$/.test(this.unmaskedPhoneConfirm) || 'Re-enter phone is invalid',
                    () => this.unmaskedPhone === this.unmaskedPhoneConfirm || "Phone numbers don't match"
                ],
                emailRules: [
                    v => (this.currentModel.settings.emailFieldRequired ? /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) : v ? /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) : true) || 'Email is invalid.',
                    v => (!this.currentModel.settings.emailFieldRequired || !!v) || 'Email is required'
                ],
                phone: null
            }
        },
        computed: {
            unmaskedPhone() {
                return this.unmask(this.$store.state.currentContactInfo.formData.phone, '(###)-###-####');
            },
            unmaskedPhoneConfirm() {
                console.log('test work');
                return this.unmask(this.$store.state.currentContactInfo.formData.phoneConfirm, '(###)-###-####');
            },
            unmaskedCleanPhone() {
                return ('001' + this.unmaskedPhone);
            },
            ownerContacts() {
                return this.$store.state.ezyvet.contacts;
            },
            smsDisclaimer() {
                return this.$store.state.currentModel.settings.localizedContent['sms_disclaimer'] || null;
            },
            smsOptinLabel() {
                return this.$store.state.currentModel.settings.localizedContent['sms_optin_label'] || 'Opt to receive text notifications?';
            },
            optOutWarning() {
                return this.$store.state.currentModel.settings.localizedContent['sms_text_optout_message'] || null;
            },
            ownerContactIsValid() {
                return !(this.currentContactInfo.isValid && this.currentContactInfo.formData.optIn);
            },
        },
        methods: {
            ownerSelectionChanged() {
                const contact = this.$store.state.ezyvet.contact;
                this.$store.state.currentDemographic = {
                    formData: {
                        firstName: contact.firstName,
                        lastName: contact.lastName,
                        dob: '',
                        contactId: contact.id
                    },
                    isValid: true
                };
                this.$store.dispatch('fetchAnimals', { contactId: contact.id });
            },
            phoneChanged() {
                this.currentContactInfo.formData.unmaskedPhone
                    = this.unmask(this.currentContactInfo.formData.phone, '(###)-###-####');
            },
            confirmPhoneChanges() {
                this.currentContactInfo.formData.unmaskedPhoneConfirm
                    = this.unmask(this.currentContactInfo.formData.phoneConfirm, '(###)-###-####');
                this.$store.dispatch('fetchOwnerDetails', { value: this.unmaskedCleanPhone });
            },
            validatePhone: async function () {
                if (this.unmaskedPhone && this.unmaskedPhone.length === 10) {
                    let isValid = true;
                    await axios.get(`${this.$store.state.settingsApi}/validate_phone/${this.unmaskedPhone}`).then(r => { isValid = r.data; });
                    return isValid;
                }
                return true;
            }
        },
        mounted() {
            this.$refs.contactInfoForm.resetValidation();
        }
    }
</script>

<style>
    #phone, #phoneConfirm {
        letter-spacing: 2px;
    }

    .v-application .v-btn-toggle.has-2-toggles > .v-btn {
        width: 50%;
    }
</style>
